(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-section/assets/javascripts/casino-section.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-section/assets/javascripts/casino-section.js');

'use strict';

const _svs$components$casin = svs.components.casino_react,
  CasinoGrid = _svs$components$casin.CasinoGrid,
  CasinoGridVirtualized = _svs$components$casin.CasinoGridVirtualized,
  CasinoNoSearchResults = _svs$components$casin.CasinoNoSearchResults;
const GridDisplayModes = svs.components.casino_react.common.constants.GridDisplayModes;
const CasinoSectionHeader = svs.components.casino_react.casinoSection.CasinoSectionHeader;
const CasinoGamesListComponent = _ref => {
  let isLoading = _ref.isLoading,
    fetchMore = _ref.fetchMore,
    displayMode = _ref.displayMode,
    items = _ref.items,
    totalGamesCount = _ref.totalGamesCount;
  if (fetchMore) {
    return React.createElement(CasinoGridVirtualized, {
      displayMode: displayMode,
      fetchMore: fetchMore,
      isLoading: isLoading,
      items: items,
      totalGamesCount: totalGamesCount
    });
  }
  return React.createElement(CasinoGrid, {
    displayMode: displayMode,
    isLoading: isLoading,
    items: items
  });
};
const CasinoSection = _ref2 => {
  let ActionButtons = _ref2.ActionButtons,
    displayMode = _ref2.displayMode,
    fetchMore = _ref2.fetchMore,
    totalGamesCount = _ref2.totalGamesCount,
    isLoading = _ref2.isLoading,
    items = _ref2.items,
    title = _ref2.title,
    _ref2$isSearchResult = _ref2.isSearchResult,
    isSearchResult = _ref2$isSearchResult === void 0 ? false : _ref2$isSearchResult;
  const isListEmpty = !(items !== null && items !== void 0 && items.length);
  const noSearchResult = isListEmpty && !isLoading && isSearchResult;
  return React.createElement("section", {
    className: "casino-section"
  }, React.createElement(CasinoSectionHeader, {
    ActionButtons: ActionButtons,
    title: title
  }), noSearchResult && React.createElement(CasinoNoSearchResults, null), !noSearchResult && React.createElement(CasinoGamesListComponent, {
    displayMode: displayMode,
    fetchMore: fetchMore,
    isListEmpty: isListEmpty,
    isLoading: isLoading,
    isSearchResult: isSearchResult,
    items: items,
    totalGamesCount: totalGamesCount
  }));
};
setGlobal('svs.components.casino_react.casinoSection.CasinoSection', CasinoSection);

 })(window);